import classNames from 'classnames';

import type { HeadingProps } from './types';
import './heading.scss';

export const Heading = ({ className, level, children, as, ...other }: HeadingProps) => {
  const levelAdjusted2 = level === 'h1-display' ? 'h1' : level;
  const levelAdjusted = levelAdjusted2 === 'h6-small' || levelAdjusted2 === 'h6-xs' ? 'h6' : levelAdjusted2;
  const HeadingComponent = as ?? levelAdjusted;

  return (
    <HeadingComponent className={classNames('payflow-ui heading', level, className)} {...other}>
      {children}
    </HeadingComponent>
  );
};
